module.exports = __webpack_public_path__ + "img/Dantam Hair 12.32207e66.jpg";